import { PriceProvidersRepository, SiloIncentivesController } from '@silo/typechain';
import { getIsSiloGovernanceToken, getRewardsTokenAddress } from './config';
import { getSiloTokenPrice } from 'data/silo-token-price/client';
import { BigIntWithDecimals, NATIVE_CURRENCY_DECIMALS, ProtocolInstance } from '@silo/types';
import { convertCurrency } from '@silo/utils';
import { ARB_WBTC_S_TOKEN_ADDRESS } from '@silo/config';

export const fetchEmissionPerSecond = async (
  siloIncentivesController: SiloIncentivesController,
  shareTokenAddress: string
) => {
  if (shareTokenAddress === ARB_WBTC_S_TOKEN_ADDRESS) {
    return 0n;
  }

  try {
    return await siloIncentivesController
      .getAssetData(shareTokenAddress)
      .then(([, emissionPerSecond]) => emissionPerSecond.toBigInt());
  } catch (err) {
    return 0n;
  }
};

interface GetRewardsPriceUsdParams {
  protocolInstance: ProtocolInstance;
  quotePrice: BigIntWithDecimals;
  priceProvidersRepositoryContract: PriceProvidersRepository;
}

/**
 * Use to fetch the rewards price USD from the client
 */
export async function getRewardsPriceUsd({
  protocolInstance,
  quotePrice,
  priceProvidersRepositoryContract,
}: GetRewardsPriceUsdParams) {
  const rewardsTokenAddress = getRewardsTokenAddress(protocolInstance);

  /**
   * If the rewards token for the protocol instance is the silo governance
   * token, use an external price feed. Otherwise, assume the rewards token has
   * a price provider within the Silo protocol.
   */
  const isSiloGovernanceToken = !!rewardsTokenAddress && getIsSiloGovernanceToken(rewardsTokenAddress);

  if (isSiloGovernanceToken) {
    return getSiloTokenPrice();
  }

  const value = await priceProvidersRepositoryContract.getPrice(rewardsTokenAddress);
  const nativePrice: BigIntWithDecimals = { value: value.toBigInt(), decimals: NATIVE_CURRENCY_DECIMALS };
  const priceUsd = convertCurrency(nativePrice, quotePrice);

  return priceUsd;
}
